import PropTypes from 'prop-types';

import { parseTitle } from '../../../utils/title-parser';
import Image from '../shared/image.component';

import { Button, Shapes } from '../shared';
import useResponsive from '../../../utils/responsive';


const HeroSection = (props) => {

    const {
        isLeadGen,
        isLeadGenSales,
        title,
        id,
        subheading,
        paragraph,
        paragraphTwo,
        negativeMargin,
        imgSrc,
        imgAlt,
        hasButton,
    } = props;

    const isMainHeaderOne = true;    

    const goToForm = () => {
        const element = document.getElementById('get-in-touch-form');
        element.scrollIntoView();
    };

    const { isMobile, isTablet } = useResponsive();

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            if (id === 'corporate_bookings_header') {
                return (
                    <>
                        <Shapes
                            isPair
                            isDark
                            speed={0.07}
                            containerMargins={{ left: '-5%', top: '70%' }}
                            degrees="-38.66deg"
                            smallMargins={{ width: 50, height: 23 }}
                            largeMargins={{ width: 86, height: 43 }}
                            distanceBetween={{ width: '0%', height: '25%' }}
                            zIndex={3}
                        />
                        <Shapes
                            isDots
                            speed={-0.1}
                            containerMargins={{ top: '13.5%', left: '0%' }}
                            smallMargins={{ width: '52%', height: '40%' }}
                            zIndex={1}
                        />
                        <Shapes
                            isSingle
                            speed={0.2}
                            containerMargins={{ left: '65%', top: '30%' }}
                            degrees="39.51deg"
                            largeMargins={{ width: 204.77, height: 102.39 }}
                            distanceBetween={{ width: '0%', height: '25%' }}
                            zIndex={1}
                        />
                        <div className='hero-image-container'>
                            <Image
                                style={{ zIndex: 1 }}
                                src={imgSrc}
                                alt={imgAlt}
                                className='hero-section-image'
                                isOldImage
                            />
                        </div>
                    </>
                );
            }
            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        speed={0.15}
                        containerMargins={{ left: '78%', top: '27%' }}
                        degrees="36.34deg"
                        smallMargins={{ width: 50, height: 23 }}
                        largeMargins={{ width: 86, height: 43 }}
                        distanceBetween={{ width: '0%', height: '10%' }}
                        zIndex={3}
                    />
                    <Shapes
                        isDots
                        speed={-0.07}
                        containerMargins={{ top: '25.5%', left: '1.5%' }}
                        smallMargins={{ width: '47%', height: '40%' }}
                        zIndex={1}
                    />
                    <div className='hero-image-container'>
                        <Image src={imgSrc} alt={imgAlt} className='hero-section-image' isOldImage />
                    </div>
                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile && isTablet) {
            if (id === 'corporate_bookings_header') {
                return (
                    <>
                        <Shapes
                            isPair
                            isDark
                            speed={0.07}
                            containerMargins={{ left: '0%', top: '70%' }}
                            degrees="-38.66deg"
                            smallMargins={{ width: 25.26, height: 12.63 }}
                            largeMargins={{ width: 43.44, height: 21.72 }}
                            distanceBetween={{ width: '0%', height: '25%' }}
                            zIndex={3}
                        />
                        <Shapes
                            isDots
                            speed={-0.1}
                            containerMargins={{ top: '13.5%', left: '-35%' }}
                            smallMargins={{ width: '40%', height: '40%' }}
                            zIndex={1}
                        />
                        <Shapes
                            isSingle
                            speed={0.2}
                            containerMargins={{ left: '66%', top: '23%' }}
                            degrees="39.51deg"
                            largeMargins={{ width: 103.44, height: 51.72 }}
                            distanceBetween={{ width: '0%', height: '25%' }}
                            zIndex={1}
                        />

                        <div className='hero-image-container'>
                            <Image
                                style={{ zIndex: 1 }}
                                src={imgSrc}
                                alt={imgAlt}
                                className='hero-section-image'
                                isOldImage
                            />
                        </div>
                    </>
                );
            }

            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        speed={0.15}
                        containerMargins={{ left: '74%', top: '15%' }}
                        degrees="36.34deg"
                        smallMargins={{ width: 17.18, height: 8.59 }}
                        largeMargins={{ width: 29.56, height: 14.78 }}
                        distanceBetween={{ width: '0%', height: '25%' }}
                        zIndex={2}
                    />

                    <Shapes
                        isDots
                        offset={0}
                        speed={-0.07}
                        containerMargins={{ top: '29.5%', left: '-43%' }}
                        smallMargins={{ width: '31%', height: '40%' }}
                        zIndex={1}
                    />

                    <div className='hero-image-container'>
                        <Image src={imgSrc} alt={imgAlt} className='hero-section-image' isOldImage />
                    </div>

                </>
            );
        }
        return null;
    };

    const renderImageSection = () => {
        return (
            <div style={{ position: 'relative' }}>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
            </div>
        );
    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='hero-section-grid-container'>

                <div className='hero-section-text-grid-container hero-section-grid-md-6 hero-section-grid-item'>

                    <div className='hero-section-header'>
                        {parseTitle(title, id, isMainHeaderOne)}
                    </div>

                    <div>

                        <h5 id="home_subheading">{subheading}</h5>

                        {paragraph && <p className='hero-section-paragraph'>{paragraph}</p>}

                        {paragraphTwo && <p className='hero-section-paragraph' id="home_hero_paragraph_two">{paragraphTwo}</p>}

                        {hasButton && (
                            <Button
                                id="hero-section-button"
                                variant="contained"
                                color="primary"
                                onClick={goToForm}
                                style={{ marginTop: 24 }}
                            >
                                Get in Touch
                            </Button>
                        )}

                    </div>

                </div>

                <div className={`hero-section-grid-md-6 hero-section-grid-item ${props.negativeMargin ? 'hero-section-negative-margin' : ''}`}>
                    {renderImageSection()}
                </div>

            </div>

        </div>
        
    );
};

export default HeroSection;

HeroSection.propTypes = {
    negativeMargin: PropTypes.bool,
    isLeadGen: PropTypes.string,
    isLeadGenSales: PropTypes.bool,
    title: PropTypes.string,
    subheading: PropTypes.string,
    paragraph: PropTypes.string,
    paragraphTwo: PropTypes.string,
    id: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    hasButton: PropTypes.bool,
};

